import { render, staticRenderFns } from "./AddOrEditAppointmentByForm.vue?vue&type=template&id=a30187f2"
import script from "./AddOrEditAppointmentByForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditAppointmentByForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditAppointmentByForm.vue?vue&type=style&index=0&id=a30187f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports